import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Global native saveAs fallback to guarantee 100% download reliability across all tools
if (typeof window !== 'undefined' && !(window as any).saveAs) {
  (window as any).saveAs = function(blob: Blob | string, filename: string) {
    try {
      const url = typeof blob === 'string' ? blob : URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || 'download';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      if (typeof blob !== 'string') {
        setTimeout(() => URL.revokeObjectURL(url), 15000);
      }
    } catch (e) {
      console.error('saveAs fallback failed:', e);
    }
  };
}

// Smoothly dismiss brand preloader once React App is ready
if (typeof (window as any).__removePreloader === 'function') {
  requestAnimationFrame(() => {
    (window as any).__removePreloader();
  });
}

